// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon-module_icon__3FMwL"};